var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8274_77)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5345 23C41.7795 23.0146 40.1017 23.6505 38.8645 24.77L24.5208 37.64C23.8995 38.2021 23.5508 38.9624 23.5508 39.755C23.5508 40.5476 23.8995 41.3079 24.5208 41.87C24.8309 42.1512 25.1998 42.3744 25.6063 42.5267C26.0128 42.679 26.4488 42.7574 26.8892 42.7574C27.3295 42.7574 27.7655 42.679 28.172 42.5267C28.5785 42.3744 28.9474 42.1512 29.2575 41.87L40.1988 32V62C40.1988 62.7956 40.5502 63.5587 41.1758 64.1213C41.8013 64.6839 42.6498 65 43.5345 65C44.4192 65 45.2676 64.6839 45.8932 64.1213C46.5188 63.5587 46.8702 62.7956 46.8702 62V32L57.8448 41.87C58.4685 42.4349 59.3162 42.7539 60.2014 42.7567C61.0866 42.7595 61.9367 42.4459 62.5649 41.885C63.193 41.3241 63.5476 40.5617 63.5508 39.7656C63.5539 38.9695 63.2052 38.2049 62.5815 37.64L48.2379 24.77C46.9925 23.6432 45.301 23.0067 43.5345 23Z",
    fill: "#D6D6D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8274_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.1d999da70f758803bf3660c21c19c170.svg";
export { ForwardRef as ReactComponent };